<template>
  <div class="sim-card">
    <div class="row">
      <div class="col-sm-6">
        <p class="h4"><strong>Number:</strong> {{ simcard.number }}</p>
        <p class="h4"><strong>Pin:</strong> {{ simcard.pin }}</p>
        <p class="h4"><strong>PUK Code:</strong> {{ simcard.puk }}</p>
        <p class="h4"><strong>Provider:</strong> {{ simcard.provider }}</p>
        <p class="h4"><strong>Plan Type:</strong> {{ simcard.planType }}</p>
        <p class="h4"><strong>Serial Number:</strong> {{ simcard.serialNumber }}</p>
      </div>
      <div class="col-sm-6">
        <h4>Currently in use by:</h4>
        <p class="h4" v-if="simcard.Car">{{ simcard.Car.dropdownLabel }}</p>
        <img v-if="simcard.Car" :src="carImage"/>
        <p class="h4" v-if="simcard.NPort">{{ simcard.NPort.location }}</p>
      </div>
    </div>
    <div class="toolbar text-right">
      <router-link class="btn btn-default"
            :to="{ path: `/hardware/sim-cards/edit/${simcard.uuid}` }">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SimCard',
  props: {
    object: {
      type: Object
    }
  },
  computed: {
    carImage () {
      return 'https://techcar-dev.s3.amazonaws.com/' +
      this.simcard.Car.CarType.AmazonImage.objectKey
    }
  },
  data () {
    return {
      simcard: {
        Car: {
          name: '',
          CarType: {
            AmazonImage: {
              objectKey: 'spacer.gif'
            }
          }
        }
      }
    }
  },
  mounted () {
    this.simcard = this.object
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cards/SimCard.vue